export const DELTA_LINE_LABELS = {
  vsPrefix: 'vs',
} as const
